import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import QuestionCircle from '@deliveroo/icon-set/react/QuestionCircle';
import LoadingIndicator from '@deliveroo/consumer-component-library/components/LoadingIndicator';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import P from '@deliveroo/consumer-component-library/components/P';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import i18n from '../../utils/i18n';

import OrderDetailsColumnContainer from '../../containers/OrderDetailsColumn';

import styles from './styles.scss';

export default function OrderStatusSkeleton({ orderId, attributes }) {
  return (
    <div className={styles.content}>
      <div className={styles.primary}>
        <div className={styles['order-help-link-container']}>
          <a
            className={styles['order-help-link']}
            href={`/orders/${orderId}/help?redirectTo=/orders/${orderId}/status`}
          >
            <span className={styles['order-help-link-icon']}>
              <Icon component={QuestionCircle} size={18} />
            </span>

            {i18n.gettext('order_status_page.order_help')}
          </a>
        </div>

        <div className={styles['loading-details']}>
          {attributes ? (
            <Fragment>
              <Heading level={4} spacing="0 0 small">
                {attributes.title}
              </Heading>
              <P color="grey" spacing="0 0 small">
                {attributes.message}
              </P>
            </Fragment>
          ) : (
            <Heading level={4} spacing="0 0 small">
              {i18n.gettext('order_status_post_checkout_loading_screen_status')}
            </Heading>
          )}

          <LoadingIndicator adjacentHorizontalSpacing="small" color="teal" />
        </div>
      </div>

      <div className={styles.secondary}>
        <OrderDetailsColumnContainer />
      </div>
    </div>
  );
}

OrderStatusSkeleton.propTypes = {
  attributes: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
  }),
  /* The id of the order */
  orderId: PropTypes.string.isRequired,
};

OrderStatusSkeleton.defaultProps = {
  attributes: null,
};
